import { IconButton as IButton, Tooltip  } from "@mui/material";

const IconButton = ({text, iconCmp, handler, ...params}) => {
    return (
        <Tooltip title={text}>
            <span><IButton 
                color= 'inherit'
                onClick={handler}
                {...params}
            >
                {iconCmp}
            </IButton></span>
        </Tooltip>
    );  
};

export default IconButton;